import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useDevAuth } from "@/context/DevAuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const { refresh: refreshDev, setDev } = useDevAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (location.pathname.startsWith("/espace-developpeur")) {
      api
        .post("/dev/auth/google", { session_id: sessionId, kind: sessionStorage.getItem("fmo_signup_kind") || undefined })
        .then(async ({ data }) => {
          if (data.admin) {
            setUser(data.user);
            navigate("/admin", { replace: true, state: { user: data.user } });
            return;
          }
          await refreshDev();
          navigate("/espace-developpeur", { replace: true });
        })
        .catch((err) => {
          setDev(false);
          const error = err?.response?.status === 403 ? "err.adminEmail" : "err.googleFailed";
          navigate("/espace-developpeur/connexion", { replace: true, state: { error } });
        });
      return;
    }
    api
      .post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        navigate("/admin", { replace: true, state: { user: data.user } });
      })
      .catch((err) => {
        setUser(false);
        const error = err?.response?.status === 403 ? "err.denied" : "err.googleFailed";
        navigate("/admin/login", { replace: true, state: { error } });
      });
  }, [location.hash, location.pathname, navigate, setUser, refreshDev, setDev]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--carbon)]" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-[var(--gold)]" />
    </div>
  );
};
